import _ from "lodash";
import client from "lib/apolloClient/client";

import { getAIConversationsFlaggedMessagesQuery } from "./AITutorFlaggedMessagesQueries";

export const getAIConversationsFlaggedMessagesFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getAIConversationsFlaggedMessagesQuery,
      variables,
    });

    return _.get(queryData, "node") || {};
  } catch (e) {
    return {};
  }
};
